import { usePage } from '@inertiajs/react';
import type { HackerWaitingListsShow } from '@/types';
import { WaitingListForm } from './components/WaitingListForm';
import { WaitingListResponseReceived } from './components/WaitingListResponseReceived';

// /hacker/:publicId/waiting-list. The shell (page background + Platanus mask) is the same
// on both branches, exactly as in the Next page.
export default function Show({
  publicId,
  statusData,
  joined,
}: HackerWaitingListsShow) {
  // `errorValueType` is `string[]` app-wide, but this controller ships one message under
  // `base` — the refusal the Next action rendered under the button.
  const errors = usePage().props.errors as unknown as Record<
    string,
    string | undefined
  >;

  return (
    <div className="min-h-screen bg-background">
      <div className="container relative mx-auto px-4 py-12 md:py-16">
        <div className="absolute top-4 right-4 z-20 sm:top-6 sm:right-6 md:top-8 md:right-8">
          <div
            className="aspect-[576/112] h-7 w-auto sm:h-9 md:h-10"
            style={{
              backgroundColor: 'hsl(var(--primary))',
              maskImage: 'url(/assets/logos/platanus.svg)',
              maskSize: 'contain',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskImage: 'url(/assets/logos/platanus.svg)',
              WebkitMaskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
            }}
          />
        </div>

        <div className="mx-auto w-full max-w-3xl">
          {joined ? (
            <WaitingListResponseReceived
              modality={statusData.submission.modality}
              eventName={statusData.event.name}
              eventSlug={statusData.event.slug}
            />
          ) : (
            <WaitingListForm
              publicId={publicId}
              statusData={statusData}
              error={errors.base ?? null}
            />
          )}
        </div>
      </div>
    </div>
  );
}
